import { isArray, isEmpty } from 'lodash-es';
import type {
  AppVersionApplicationFile,
  ParameterTemplate,
} from '../pages/applications-version-details-page/applicationVersionDetails.model';
import type {
  AppVersionApplicationFile as OsAppVersionApplicationFile,
  ParameterTemplate as OsParameterTemplate,
} from '../pages/create-os-version-page/createOsVersionPage.model';
import { isArrayOfParameterTemplate as isOsArrayOfParameterTemplate } from '../pages/create-os-version-page/createOsVersionPage.model';
import type {
  AppVersionApplicationFile as SystemPackageAppVersionApplicationFile,
  ParameterTemplate as SystemPackageParameterTemplate,
} from '../pages/create-system-package-version-page/createSystemPackageVersionPage.model';
import { isArrayOfParameterTemplate } from '../pages/create-system-package-version-page/createSystemPackageVersionPage.model';

export function getAllFilesFromApplicationParameterTemplate(
  arrayOfParameterTemplate?: ParameterTemplate[],
): AppVersionApplicationFile[] {
  const output: AppVersionApplicationFile[] = [];

  if (!isArray(arrayOfParameterTemplate)) {
    return output;
  }
  arrayOfParameterTemplate.forEach(({ template }) => {
    output.push(template[0]);
  });
  return output.filter((el) => !isEmpty(el));
}

// Only had todo both types because formulary is suddently changing types between computations.
export function getAllFilesFromSystemPackageParameterTemplate(
  arrayOfParameterTemplate?: SystemPackageAppVersionApplicationFile[] | SystemPackageParameterTemplate[],
): SystemPackageAppVersionApplicationFile[] {
  const output: SystemPackageAppVersionApplicationFile[] = [];

  if (!isArray(arrayOfParameterTemplate)) {
    return output;
  }
  if (!isArrayOfParameterTemplate(arrayOfParameterTemplate)) {
    return arrayOfParameterTemplate;
  }
  arrayOfParameterTemplate
    .filter(({ template }) => isArray(template) && template.length > 0)
    .forEach(({ template }) => {
      output.push(template[0]);
    });

  return output.filter((el) => !isEmpty(el));
}

export function getAllFilesFromOsVersionParameterTemplate(
  arrayOfParameterTemplate?: OsAppVersionApplicationFile[] | OsParameterTemplate[],
): OsAppVersionApplicationFile[] {
  const output: OsAppVersionApplicationFile[] = [];

  if (!isArray(arrayOfParameterTemplate)) {
    return output;
  }
  if (!isOsArrayOfParameterTemplate(arrayOfParameterTemplate)) {
    return arrayOfParameterTemplate;
  }
  arrayOfParameterTemplate
    .filter(({ template }) => isArray(template) && template.length > 0)
    .forEach(({ template }) => {
      output.push(template[0]);
    });

  return output.filter((el) => !isEmpty(el));
}
